/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Fragment Payments API
 * REST API for Fragment payment operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * Operation type - delete an existing line item
 */
export type DeleteLineItemOperationOp = (typeof DeleteLineItemOperationOp)[keyof typeof DeleteLineItemOperationOp];

export const DeleteLineItemOperationOp = {
  delete: 'delete',
} as const;
